import React, { Component } from 'react';
import { FormGroup, Label, Col, Button } from 'reactstrap';
import { Field } from 'formik';

import ButtonIcon from 'components/helpers/ButtonIcon';

export class Text extends Component {
  render() {
    const {
      errors,
      touched,
      className,
      label,
      disabled,
      id,
      type,
      icon,
      inputWidth,
      value,
      onChange,
      onRemove,
      iconClass,
      labelClassName,
      ...other
    } = this.props;

    return (
      <FormGroup
        className={`${className ? className : ''} ${
          errors && touched && touched[this.props.name] && errors[this.props.name]
            ? 'has-error'
            : ''
        }`}
        row
      >
        {label && (
          <Col sm={inputWidth ? inputWidth : 12}>
            <Label
              className={`mb-0 ${disabled ? 'text-muted' : ''} ${
                errors && errors[this.props.name] ? 'text-danger' : ''
              } ${labelClassName}`}
              for={id}
              sm={12}
            >
              {label}
            </Label>
          </Col>
        )}
        <Col sm={inputWidth ? inputWidth : 12}>
          <Field
            type={type ? type : 'text'}
            className="form-control pl-1"
            disabled={disabled && disabled !== undefined ? true : false}
            value={value ? value : ''}
            onChange={onChange}
            {...other}
          />
        </Col>

        {onRemove && onRemove !== undefined && typeof onRemove === 'function' && (
          <Button
            color="link"
            type="button"
            className="btn-remove"
            onClick={e => onRemove(this.props.name)}
          >
            <ButtonIcon icon="times" />
          </Button>
        )}

        {errors && touched && touched[this.props.name] && errors[this.props.name] && (
          <Label className="text-danger">{errors[this.props.name]}</Label>
        )}
        {icon ? <ButtonIcon className={`text-icon mr-4 ${iconClass}`} icon={icon} /> : null}
      </FormGroup>
    );
  }
}

export default Text;



// WEBPACK FOOTER //
// ./src/components/inputs/Text.js